"use client";

import { useEffect, useState } from "react";

const THEME_KEY = "cybitix-theme";

type Theme = "dark" | "light";

function getStoredTheme(): Theme | null {
  if (typeof window === "undefined") {
    return null;
  }
  const stored = window.localStorage.getItem(THEME_KEY);
  return stored === "light" || stored === "dark" ? stored : null;
}

export default function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(() => getStoredTheme() ?? "dark");

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  const nextTheme = theme === "dark" ? "light" : "dark";

  return (
    <button
      type="button"
      onClick={() => {
        setTheme(nextTheme);
        document.documentElement.dataset.theme = nextTheme;
        window.localStorage.setItem(THEME_KEY, nextTheme);
      }}
      className="inline-flex items-center gap-2 rounded-lg border border-[var(--stroke)] bg-[var(--panel)]/70 px-3 py-1.5 text-xs font-semibold text-[var(--text)] transition hover:border-[var(--accent)]"
      aria-label={`Switch to ${nextTheme} theme`}
    >
      <span className="h-2 w-2 rounded-full bg-[var(--accent)]"></span>
      {theme === "dark" ? "Dark" : "Light"}
    </button>
  );
}
